import { render, staticRenderFns } from "./InputStart.vue?vue&type=template&id=6035df8f&scoped=true&"
import script from "./InputStart.vue?vue&type=script&lang=js&"
export * from "./InputStart.vue?vue&type=script&lang=js&"
import style0 from "./InputStart.vue?vue&type=style&index=0&id=6035df8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035df8f",
  null
  
)

export default component.exports